import { RESET_FORM } from '../actionTypes';
import { panelLayoutV2Actions } from '../reducer';

export default () => panelLayoutV2Actions[RESET_FORM]();
